import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Article from "./views/Article.vue";
import Firebase from "@/firebase";
import Shell from "@/views/Shell.vue";

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    console.log(savedPosition);

    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  mode: "history",
  routes: [
    {
      path: "",
      name: "main",
      component: Shell,
      redirect: "/home",
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/home",
          name: "Home",
          component: Home,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/articles/:id",
          name: "Article",
          component: Article,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/tags",
          name: "Tags",
          component: () => import("./views/Tags.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/stats",
          name: "Stats",
          component: () => import("./views/Stats.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/social",
          name: "Social",
          component: () => import("./views/Social.vue"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: Login
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const user = await Firebase.getCurrentUser();
  if (requiresAuth && !user) {
    next("login");
  } else {
    next();
  }
});

export default router;
